<template>
  <div class="app-menu-standard">
    <div
      v-for="item in list"
      :key="item.path || item.action"
      class="app-menu-standard__item"
      :class="{ active: $route.path.indexOf(item.path) !== -1 || $route.path.indexOf(item.related) !== -1, 'is-claw': item.name === 'clawSkills' }"
      @click="onClick(item)"
    >
      {{ $t(`app.menu.${item.name}`) }} <span class="new" v-if="item.name === 'datasub'">NEW</span>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { IS_PRODUCT_HOST } from '@/utils'
import { generateSid } from '@/services/auth'

const router = useRouter()
const store = useStore()
const isProduct = IS_PRODUCT_HOST
const menuList = ref([
  {
    path: '/detect',
    name: 'submit'
  },
  {
    path: '/taskhub',
    related: 'report',
    name: 'task'
  },
  // {
  //   path: '/hunting',
  //   name: 'hunting'
  // },
  {
    path: '/datasub',
    name: 'datasub'
  },
  {
    path: '/help',
    name: 'help'
  },
  {
    path: '/price',
    name: 'upgrade'
  },
  {
    path: '/skillsguard/',
    related: 'skillsguard',
    name: 'clawSkills'
  },
  {
    name: 'agent',
    action: 'agent',
    ref: `${window.location.origin}/automaton/auth/ata`
  }
])

const list = computed(() => {
  return !isProduct ? menuList.value : menuList.value.filter(item => item.path !== '/datasub' && item.action !== 'agent')
})

const onClick = (item) => {
  if (item.action === 'agent') {
    // 未登录：直接跳转到智能体页面，让用户自行登录
    if (!store.getters.isLogin) {
      window.open(`${window.location.origin}/automaton/`, '_blank')
      return
    }
    // 已登录：生成 SID 并跳转到智能体页面
    generateSid({
      app: 'ata-agent',
      ref: item.ref
    }).then((res) => {
      const sid = typeof res === 'object' ? (res.sid || res.data || res) : res
      if (sid) {
        const redirectUrl = `${item.ref}${item.ref.includes('?') ? '&' : '?'}sid=${sid}`
        window.open(redirectUrl, '_blank')
      }
    })
    return
  }
  if (item.path === '/skillsguard/') {
    window.open(item.path, '_blank')
  } else {
    router.push(item.path)
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/common.scss';
.app-menu-standard {
  display: inline-flex;
  &__item {
    position: relative;
    display: inline-block;
    width: 104px;
    height: $header-height;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--color-text-2);
    cursor: pointer;
    &:hover {
      color: var(--color-text-1);
    }
    &.active {
      color: var(--color-text-1);
      &::after {
        content: '';
        display: inline-block;
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 3px;
        background-color: var(--color-primary);
      }
    }
    .new {
      background: linear-gradient(90deg, #FF4646 4%, #FF7C62 100%);
      border-radius: 4px;
      font-size: 8px;
      font-weight: 500;
      color: #FFFFFF;
      padding: 2px 4px;
      margin-left: 4px;
    }
    &.is-claw {
      min-width: 150px;
      white-space: nowrap;
    }
  }
}
</style>
